<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    香蜜湖站<br>
站点介绍<br>
香蜜湖站位于香梅路西侧与香蜜湖度假村出口之间的深南大道北侧绿地下，与深南大道大致平行。车站东北角紧邻香蜜湖东座酒店，西北面是香蜜湖度假村，南面是深圳市东西向主要交通干道之一的深南大道和高尔夫球场。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:04	23:49	1号线	2分钟	4分40秒<br>
机场东	06:39	23:19	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:05	23:47	1号线	3分45秒	5分45秒<br>
机场东	06:39	23:19	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:05	00:47	1号线	3分45秒	5分45秒<br>
机场东	06:39	00:19	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
市规划国土委、市人居委、市规划国土委第一直属管理局、景田派出所、莲花街道办、香蜜社区、梅岭社区、紫荆社区、香蜜二村社康中心、景田社康中心、深茂大厦、侨福大厦、深圳特区报业大厦、中投国际商务中心、景苑大厦、人民大厦、市政大厦、鲁班大厦、香蜜湖公寓、香逸名园、华泰小区单身楼、合正名园、五洲星苑、华泰小区、香蜜二村、缇香名苑、橄榄绿洲、香蜜新村、金色假日名苑、香蜜三村、深圳特区报社公寓、华强职业技术学校、景鹏小学、耀华实验学校<br><br>
B出入口:<br>
香蜜社区、规划大厦、深圳土地房产交易大厦、水榭花都、荔园外国语小学、香蜜湖度假村<br><br>
C1出入口:<br>
东方玫瑰花园、安柏丽晶<br><br>
C2出入口:<br>
高尔夫俱乐部别墅区<br><br>
公交换乘信息<br><br>
C1出入口:<br>
公交站名： 香蜜湖①<br>
21、79、101、113、215、215、222、223、234、M123、M488、M555、N4、N6、高峰62<br><br>
C2出入口:<br>
公交站名： 香蜜湖②<br>
高峰18、324、326、E38、M115、M173、M183、M391、M392、M447、M448<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>









